export enum SortRecipeCalculationsBy {
  Name = 'Name',
  CreatedAt = 'CreatedAt',
}
